// rtk详情
export default {
    operatorInformation: 'Информация об операторе',
    residualFlow: 'Оставшийся поток',
    validUntil: 'действует до',
    renew: 'возобновить',
    SCP: 'Отсканируйте QR-код для оплаты',
    connected: 'связанный',
    notConnected: 'Не подключен',
    bindingType: 'Тип переплета',
    private: 'частный',
    public: 'общественный',
}